<template>
    <button
        class="btn-question-next"
        :class="correctnessClass">
        <span class="btn-question-next__text">SONRAKİ</span>
    </button>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            correctness: { type: Number, default: null },
        },

        computed: {
            correctnessClass(){
                if(this.correctness === 1){
                    return 'btn-question-next--correct';
                }
                else if(this.correctness === 0){
                    return 'btn-question-next--incorrect';
                }
                else if(this.correctness === -1){
                    return 'btn-question-next--skipped';
                }
            }
        }
    };
</script>

<style scoped src="@/css/components/btn-question-next.css"></style>